import { Box } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { Notification } from '../../types/notification';
import styles from './styles';

export interface NotificationBadgeProps {
  classes?: Record<string, string>;
  notifications?: {
    items?: Notification[];
  };
}

function NotificationBadge({
  classes = {},
  notifications = {},
}: NotificationBadgeProps) {
  const newnotifcations =
    (notifications &&
      notifications.items &&
      notifications.items.filter((notification) => !notification.IsRead)
        .length) ||
    0;
  const displayNewNotitications = newnotifcations > 9 ? '9+' : newnotifcations;
  return (
    <>
      {newnotifcations >= 1 && (
        <Box className={classes.root}>
          <Box
            className={`notifcationBadge ${
              newnotifcations > 9 && 'notificationBadgePlus'
            }`}
            data-testid="notification-badge"
          >
            {displayNewNotitications}
          </Box>
        </Box>
      )}
    </>
  );
}

export default withStyles(styles)(NotificationBadge);
